// extracted by mini-css-extract-plugin
module.exports = {"cardHeader":"UserPrev_cardHeader__SZTGV","cardDescription":"UserPrev_cardDescription__331rK"};